import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Tag, MessageCircle, ArrowRight } from "lucide-react";
import { STORE, waLink, formatGs } from "../data/store";
import { api, assetUrl } from "../lib/api";

export const PromoStrip = ({ onNav }) => {
  const [promos, setPromos] = useState([]);

  useEffect(() => { api.listPublic("promotions").then(setPromos).catch(() => {}); }, []);

  if (promos.length === 0) return null;

  return (
    <section id="section-promos" data-testid="promo-strip" className="scroll-mt-20 bg-[#E02424] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-15"
        style={{ background: "repeating-linear-gradient(135deg, transparent 0 24px, rgba(255,255,255,.35) 24px 26px)" }} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 relative">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6">
          <div>
            <div className="flex items-center gap-2 text-[#FDE68A] font-bold text-xs tracking-widest uppercase">
              <Tag className="w-4 h-4" /> Promociones destacadas
            </div>
            <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mt-1">Ofertas de la semana</h2>
          </div>
          <p className="text-sm text-red-100 max-w-sm">Precios válidos hasta agotar stock. Consultá disponibilidad por WhatsApp.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {promos.map((p, i) => (
            <motion.div
              key={p.id} data-testid={`promo-card-${p.id}`}
              initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.07 }}
              className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-xl flex"
            >
              {p.image_url && (
                <img src={assetUrl(p.image_url)} alt={p.title} className="w-28 sm:w-32 object-cover shrink-0" loading="lazy" />
              )}
              <div className="p-4 flex flex-col flex-1 min-w-0">
                <span className="self-start px-2 py-0.5 rounded-full bg-[#F59E0B] text-white text-[10px] font-bold uppercase tracking-wide">{p.badge}</span>
                <h3 className="mt-1.5 font-display font-bold leading-snug line-clamp-2">{p.title}</h3>
                <p className="text-xs text-gray-500 mt-1 line-clamp-2 flex-1">{p.description}</p>
                <div className="mt-2 flex items-end justify-between gap-2">
                  <div>
                    {p.old_price ? <div className="text-xs text-gray-400 line-through">{formatGs(p.old_price)}</div> : null}
                    {p.price ? <div className="font-display font-black text-lg text-[#E02424] leading-none">{formatGs(p.price)}</div> : null}
                  </div>
                  {p.product_code ? (
                    <button
                      data-testid={`promo-view-${p.id}`}
                      onClick={() => onNav("search", p.product_code)}
                      className="inline-flex items-center gap-1 text-xs font-bold text-[#0A3977] hover:gap-2 transition-all"
                    >
                      Ver producto <ArrowRight className="w-3.5 h-3.5" />
                    </button>
                  ) : (
                    <a
                      data-testid={`promo-whatsapp-${p.id}`}
                      href={waLink(`Hola ${STORE.name}, consulto por la promoción "${p.title}".`)} target="_blank" rel="noreferrer"
                      className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#25D366] text-white text-xs font-bold"
                    >
                      <MessageCircle className="w-3.5 h-3.5" /> Consultar
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
